import * as React from 'react';
import { Discipline } from '../../../core/typings';
import './styles.scss';

type Stat = {
  label: string;
  value: string;
};

interface StatsProps {
  stats: Stat[];
  text?: string;
  discipline?: Discipline;
}

const Stats = ({
  stats,
  text,
  discipline,
}: StatsProps) => {
  const head = stats[0];
  const body = stats.slice(1);

  return (
    <div className={`stats ${discipline ? `stats--${discipline}` : ''}`}>
      <div className="stats__header">
        {text && (
          <div className="stats__text stats__text--mobile">{text}</div>
        )}

        <div className="stats__label">{head.label}</div>
        <div className="stats__value stats__value--head">{head.value}</div>

        {text && (
          <div className="stats__text stats__text--desktop">{text}</div>
        )}
      </div>
      <ul className="stats__body">
        {body.map((stat: Stat) => (
          <React.Fragment key={stat.label}>
            <li className="stats__item">
              <div className="stats__label">{stat.label}</div>
              <div className="stats__value">{stat.value}</div>
            </li>
          </React.Fragment>
        ))}
      </ul>
    </div>
  );
};

export default Stats;
